var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelayIcon = function SvgDelayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#delay_icon_svg__a)",
    d: "m25 11.25 11.875 6.875v13.75L25 38.75l-11.875-6.875v-13.75zm-8.133 7.597L25 23.555l8.133-4.708L25 14.14zm-1.242 2.17v9.417l8.125 4.704V25.72zm10.625 14.12 8.125-4.703v-9.417L26.25 25.72z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "delay_icon_svg__a",
    x1: 13.125,
    x2: 36.875,
    y1: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335CFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#335CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF",
    stopOpacity: 0.8
  })))));
};
export default SvgDelayIcon;